module.exports = __webpack_public_path__ + "img/a1_1.ca2e9f27.jpg";